import { format } from "date-fns";
import React, { useContext } from "react";
import { UserContext } from "../../../../Context";

export default function Chat(props) {
  const { chat } = props;
  const { user } = useContext(UserContext);

  let flexDirection = "row";
  if (chat.user && chat.user._id === user._id) flexDirection = "row-reverse";

  return (
    <div style={{ display: "flex", flexDirection }}>
      {/*   <Avatar
        size="small"
         src={chat.user && chat.user.image ? `./images/${chat.user.image}` : ""}
      ></Avatar> */}
      <div className="chat-container">
        <div className="chat-header">
          {chat.user && chat.user._id !== user._id ? chat.user.name : ""}{" "}
        </div>
        <div className="chat-content">{chat.message}</div>
        <div className="chat-timestamp">
          {" "}
          {format(new Date(chat.createdAt), "h:mm aaa EEEE dd/MM/yyyy")}
        </div>
      </div>
    </div>
  );
}
